/* eslint-disable no-useless-escape */
const application = `  func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplicationLaunchOptionsKey: Any]?) -> Bool {

    requestData()

    return true
  }`;

export const swiftEndpoints = {
    anonymousid:
`let apikey = "LIVDSRZULELA"

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for anonymous id -- for first time users
   */
  func tenorAnonymousIDHandler(response: [String:AnyObject])
  {
    // Read the anonymous id for the user
    let anonymousID = response["anon_id"] as! String

    // Store the anonymousID for use in later API calls
    UserDefaults.standard.setValue(anonymousID, forKey: "anonymousID")
  }`,

    trendinggifs:
`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web requests to retrieve trending GIFs.
   */
  func requestData()
  {
    // Define the results upper limit
    let limit = 10

    // Get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
    let trendingRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/trending?key=%@&limit=%d",
                                                             apikey,
                                                             limit))!)
    makeWebRequest(urlRequest: trendingRequest, callback: tenorTrendingResultsHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for trending top 10 GIFs.
   */
  func tenorTrendingResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let topTenGifs = response["results"]!

    // Load the GIFs into your view
    print("Trending Results: \(topTenGifs)")
  }

  }`,

    categories:
`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web requests to retrieve GIF categories.
   */
  func requestData()
  {

    // Get the current list of categories - using the default locale of en_US
    let categoryRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/categories?key=%@",
                                                             apikey))!)
    makeWebRequest(urlRequest: categoryRequest, callback: tenorCategoryResultsHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for GIF categories.
   */
  func tenorCategoryResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let categories = response["tags"]!

    // Load the categories into your view
    print("Category Results: \(categories)")
  }

  }`,

    search:
`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web request to retrieve the top GIFs returned(in batches of 8) for the given search term.
   */
  func requestData()
  {
    // the test search term
    let searchTerm = "excited"

    // Define the results upper limit
    let limit = 8

    // make initial search request for the first 8 items using default locale of EN_US
    let searchRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/search?q=%@&key=%@&limit=%d",
                                                             searchTerm,
                                                             apikey,
                                                             limit))!)

    makeWebRequest(urlRequest: searchRequest, callback: tenorSearchHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for search requests.
   */
  func tenorSearchHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let responseGifs = response["results"]!

    // Load the GIFs into your view
    print("Result GIFS: \(responseGifs)")

  }

  }`,

    registershare:
`let apikey = "LIVDSRZULELA"

  func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplicationLaunchOptionsKey: Any]?) -> Bool {

    // test values for the share example
    let gifId = "8776030"
    let searchTerm = "excited"

    // register the user's share
    registerShare(gifId: gifId, searchTerm: searchTerm)

    return true
  }

  // Function for handling a user's selection of a GIF to share.
  // In a production application, the GIF id should be the "id" field of the GIF response object that the user selected
  // to share. The search term should be the user's last search.
  func registerShare(gifId: String, searchTerm: String) {

    // Register the user's share - using the default locale of en_US
    let shareRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/registershare?key=%@&id=%@&q=%@",
                                                             apikey,
                                                             gifId,
                                                             searchTerm))!)
    makeWebRequest(urlRequest: shareRequest, callback: tenorShareHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for search requests.
   */
  func tenorShareHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let status = response["status"]!

    // Load the GIFs into your view
    print("Share Response Status: \(status)")

  }`,

    autocomplete:
`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web requests to get autocomplete suggestions.
   */
  func requestData()
  {
    // for testing, the partial search
    let partialSearch = "exc"
    let limit = 5

    // Get up to 5 results from the autocomplete suggestions - using the default locale of en_US
    let autoRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/autocomplete?key=%@&q=%@&limit=%d",
                                                             apikey,
                                                             partialSearch,
                                                             limit))!)
    makeWebRequest(urlRequest: autoRequest, callback: tenorAutoCompleteResultsHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for autocomplete requests.
   */
  func tenorAutoCompleteResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let autoSuggestions = response["results"]!

    // Load the GIFs into your view
    print("Autocomplete Results: \(autoSuggestions)")
  }

  }`,

    suggestions:
`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web requests to get search suggestions.
   */
  func requestData()
  {
    // for testing, the partial search
    let lastsearch = "excited"
    let limit = 5

    // Get the top 5 search suggestions - using the default locale of en_US
    let suggestRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/search_suggestions?key=%@&q=%@&limit=%d",
                                                             apikey,
                                                             lastsearch,
                                                             limit))!)
    makeWebRequest(urlRequest: suggestRequest, callback: tenorSuggestResultsHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for search suggestion requests.
   */
  func tenorSuggestResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let searchSuggestion = response["results"]!

    // Load the GIFs into your view
    print("Search Suggestion Results: \(searchSuggestion)")
  }

  }`,

    gifs:
`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web request to the requested gif.
   */
  func requestData()
  {
    // the test gif id
    let gifid = 8776030

    // request the gif
    let searchRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/gifs?ids=%@&key=%@",
                                                             gifid,
                                                             apikey))!)

    makeWebRequest(urlRequest: searchRequest, callback: tenorgifHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for search requests.
   */
  func tenorgifHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let responseGifs = response["results"]!

    // Load the GIFs into your view
    print("Result GIFS: \(responseGifs)")

  }

  }`,

    random:
`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web request to retrieve random gifs for the given search term.
   */
  func requestData()
  {
    // the test search term
    let searchTerm = "excited"

    // Define the results upper limit
    let limit = 8

    // make initial random request for the first 8 items using default locale of EN_US
    let searchRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/random?q=%@&key=%@&limit=%d",
                                                             searchTerm,
                                                             apikey,
                                                             limit))!)

    makeWebRequest(urlRequest: searchRequest, callback: tenorRandomSearchHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for search requests.
   */
  func tenorRandomSearchHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let responseGifs = response["results"]!

    // Load the GIFs into your view
    print("Result GIFS: \(responseGifs)")

  }

  }`,

    trendingterms:
`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web requests to retrieve trending terms.
   */
  func requestData()
  {

    // Get the current list of categories - using the default locale of en_US
    let categoryRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/trending_terms?key=%@",
                                                             apikey))!)
    makeWebRequest(urlRequest: categoryRequest, callback: tenorTermsResultsHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for GIF categories.
   */
  func tenorTermsResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let terms = response["results"]!

    // Load the categories into your view
    print("Trending Terms Results: \(terms)")
  }

  }`,

    search_stickers:
`let apikey = "LIVDSRZULELA"

  func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplicationLaunchOptionsKey: Any]?) -> Bool {

    requestData()

    return true
  }

  /**
   Execute web request to retrieve the top GIFs returned(in batches of 8) for the given search term.
   */
  func requestData()
  {
    // the test search term
    let searchTerm = "excited"

    // Define the results upper limit
    let limit = 10

    // make initial search request for the first 8 items using default locale of EN_US
    let searchRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/search?searchfilter=sticker&q=%@&key=%@&limit=%d",
                                                             searchTerm,
                                                             apikey,
                                                             limit))!)

    makeWebRequest(urlRequest: searchRequest, callback: tenorSearchHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for search requests.
   */
  func tenorSearchHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let responseStickers = response["results"]!

    // Load the GIFs into your view
    print("Result Stickers: (responseStickers)")

  }

}`,

    trending_stickers:
`let apikey = "LIVDSRZULELA"

  func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplicationLaunchOptionsKey: Any]?) -> Bool {

    requestData()

    return true
  }

  /**
   Execute web requests to retrieve trending stickers.
   */
  func requestData()
  {
    // Define the results upper limit
    let limit = 10

    // Get the top 10 trending stickers - using the default locale of en_US
    let trendingRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/trending?searchfilter=sticker&key=%@&limit=%d",
                                                             apikey,
                                                             limit))!)
    makeWebRequest(urlRequest: trendingRequest, callback: tenorTrendingResultsHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for trending top 10 stickers.
   */
  func tenorTrendingResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let topTenStickers = response["results"]!

    // Load the stickers into your view
    print("Trending Results: (topTenStickers)")
  }

}`,
};

export const swiftQuickStart = {
    launch:

`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web requests to retrieve trending GIFs and GIF categories.
   */
  func requestData()
  {
    // Define the results upper limit
    let limit = 10

    // Get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
    let trendingRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/trending?key=%@&limit=%d",
                                                             apikey,
                                                             limit))!)
    makeWebRequest(urlRequest: trendingRequest, callback: tenorTrendingResultsHandler)

    // Get the current list of categories - using the default locale of en_US
    let categoryRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/categories?key=%@",
                                                             apikey))!)
    makeWebRequest(urlRequest: categoryRequest, callback: tenorCategoryResultsHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for trending top 10 GIFs.
   */
  func tenorTrendingResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let topTenGifs = response["results"]!

    // Load the GIFs into your view
    print("Trending Results: \(topTenGifs)")
  }

  /**
   Web response handler for GIF categories.
   */
  func tenorCategoryResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let categories = response["tags"]!

    // Load the categories into your view
    print("Category Results: \(categories)")
  }

  }`,
    search:

`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web request to retrieve the top GIFs returned(in batches of 8) for the given search term.
   */
  func requestData()
  {
    // the test search term
    let searchTerm = "excited"

    // Define the results upper limit
    let limit = 8

    // make initial search request for the first 8 items
    let searchRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/search?q=%@&key=%@&limit=%d",
                                                             searchTerm,
                                                             apikey,
                                                             limit))!)

    makeWebRequest(urlRequest: searchRequest, callback: tenorSearchHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for search requests.
   */
  func tenorSearchHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let responseGifs = response["results"]!

    // Load the GIFs into your view
    print("Result GIFS: \(responseGifs)")

  }

  }`,
    registershare:

`let apikey = "LIVDSRZULELA"

  func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplicationLaunchOptionsKey: Any]?) -> Bool {

    // test values for the share example
    let gifId = "8776030"
    let searchTerm = "excited"

    // register the user's share
    registerShare(gifId: gifId, searchTerm: searchTerm)

    return true
  }

  // Function for handling a user's selection of a GIF to share.
  // In a production application, the GIF id should be the "id" field of the GIF response object that the user selected
  // to share. The search term should be the user's last search.
  func registerShare(gifId: String, searchTerm: String) {

    // Register the user's share - using the default locale of en_US
    let shareRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/registershare?key=%@&id=%@&q=%@",
                                                             apikey,
                                                             gifId,
                                                             searchTerm))!)
    makeWebRequest(urlRequest: shareRequest, callback: tenorShareHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for search requests.
   */
  func tenorShareHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let status = response["status"]!

    // Load the GIFs into your view
    print("Share Response Status: \(status)")

  }`,
    autocomplete:

`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web requests to get autocomplete suggestions.
   */
  func requestData()
  {
    // for testing, the partial search
    let partialSearch = "exc"
    let limit = 5

    // Get up to 5 results from the autocomplete suggestions - using the default locale of en_US
    let autoRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/autocomplete?key=%@&q=%@&limit=%d",
                                                             apikey,
                                                             partialSearch,
                                                             limit))!)
    makeWebRequest(urlRequest: autoRequest, callback: tenorAutoCompleteResultsHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for autocomplete requests.
   */
  func tenorAutoCompleteResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let autoSuggestions = response["results"]!

    // Load the GIFs into your view
    print("Autocomplete Results: \(autoSuggestions)")
  }

  }`,
    suggestions:

`let apikey = "LIVDSRZULELA"

${application}

  /**
   Execute web requests to get search suggestions.
   */
  func requestData()
  {
    // for testing, the partial search
    let lastsearch = "smile"
    let limit = 5

    // Get the top 5 search suggestions - using the default locale of en_US
    let suggestRequest = URLRequest(url: URL(string: String(format: "https://g.tenor.com/v1/search_suggestions?key=%@&q=%@&limit=%d",
                                                             apikey,
                                                             lastsearch,
                                                             limit))!)
    makeWebRequest(urlRequest: suggestRequest, callback: tenorSuggestResultsHandler)

    // Data will be loaded by each request's callback
  }

  /**
   Async URL requesting function.
   */
  func makeWebRequest(urlRequest: URLRequest, callback: @escaping ([String:AnyObject]) -> ())
  {
    // Make the async request and pass the resulting json object to the callback
    let task = URLSession.shared.dataTask(with: urlRequest) { (data, response, error) in
      do {
        if let jsonResult = try JSONSerialization.jsonObject(with: data!, options: []) as? [String:AnyObject] {
          // Push the results to our callback
          callback(jsonResult)
        }
      } catch let error as NSError {
        print(error.localizedDescription)
      }
    }
    task.resume()
  }

  /**
   Web response handler for search suggestion requests.
   */
  func tenorSuggestResultsHandler(response: [String:AnyObject])
  {
    // Parse the json response
    let searchSuggestion = response["results"]!

    // Load the GIFs into your view
    print("Search Suggestion Results: \(searchSuggestion)")
  }

  }`,
};
